// SATI ARCHITECTS — Portfolio Data
// Sources: https://tradingwork2003.wixsite.com/my-site-1 (8 projects)
//          https://sati-architects.com/portfolio/ (2 projects)
// Total: 10 verified projects
//
// Zone-based media: gallery order follows Source-of-Truth where set; SECTION_PLAN is editorial — merged where it reads as one spatial narrative (still sanitary / exterior purity).
//
// Optional future fragment per section or project (no UI until populated):
//   before_after_fragment: { type: 'image'|'video', source: string, labelUA?: string, labelEN?: string }
// Optional on project root (same shape, whole-project clip):
//   beforeAfterFragment: { type, source, labelUA?, labelEN? }
//
// Optional PDF plans (from Source-of-Truth zips only):
//   planPdfs: [{ href, labelUA, labelEN, secondary?: boolean }]

/** CDN thumbs: ~15–25% fewer pixels vs 1200×900, q_80 — sharp on grid; AVIF when supported. */
const wix = (hash) =>
  `https://static.wixstatic.com/media/${hash}.jpg/v1/fill/w_1080,h_810,al_c,q_80,enc_avif,quality_auto/${hash}.jpg`;
const wixP = (hash) =>
  `https://static.wixstatic.com/media/${hash}.jpg/v1/fill/w_810,h_1080,al_c,q_80,enc_avif,quality_auto/${hash}.jpg`;
const weblium = (hash) =>
  `https://res2.weblium.site/res/683f0c1d5fa86d50fa4cdb30/${hash}_optimized`;

/** Raster URL for site-wide and listing OG/Twitter defaults — Hodosivka opening frame (explicit slug, not `projects[]` order). */
export const SITE_DEFAULT_OG_IMAGE = wix('542a9a_47076af9879e485c9946df6b21ab111f~mv2');
export const PORTFOLIO_INDEX_OG_IMAGE = SITE_DEFAULT_OG_IMAGE;

const rawProjects = [
  {
    id: "hodosivka-residence",
    slug: "hodosivka-residence",
    category: "interiors",
    previewPath: "hodosivka",
    titleUA: "Hodosivka",
    titleEN: "Hodosivka",
    locationUA: "Київська обл.",
    locationEN: "Kyiv Region",
    year: "2024",
    area: "327 m\u00B2",
    descriptionUA: "Приватна резиденція з архітектурним характером у Ходосівці. Візуалізації інтер\u2019єру.",
    descriptionEN: "Private residence with architectural character in Hodosivka. Interior visualizations.",
    planPdfs: [],
    // Curatorial: 4 blocks — студія (+ прихожа), спальня/гардероб (+ дитяча), санвузли, спортзал/ігрова (zip zones preserved within each block).
    gallery: [
      { src: wix("542a9a_47076af9879e485c9946df6b21ab111f~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_d20c049f0af94b49888d738826599481~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_2667a7806b5d4ed69fbf9d7656d23235~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_68ac77302d92429c8f31c8ee7cfb4fda~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_d1a1e0921bdb4d3f9e420e2ac37c4cd3~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_cdbed26d62dd479088f4e37ae4fa2b27~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_f8bba1c75d1443bca7c68702a7fc8752~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_fc7507fb25c84549abbeca0cb9dc91ae~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_d0d5308f82f94e25b66d4699583774ec~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_996e0bf420d24bdd82ee9cc9160664c8~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_4ffd8d5d5a5645379be8da4761f70bca~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_f8bba1c75d1443bca7c68702a7fc8752~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_9e9fe90bcff742c3b8dba2a4935769d6~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_64ebbdfcf3e446e08f071fac3c3da3a3~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_64ebbdfcf3e446e08f071fac3c3da3a3~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_1f1630778dd14cb3adc3611fe8e2afc9~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_202d78a77a634286ba5bb1c0d3b5a575~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_6e1fb1797df64c97a539105432e1b840~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_b317b98cad504a188c4aacf930b4ff97~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_6e1fb1797df64c97a539105432e1b840~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "igor-gracie-academy",
    slug: "igor-gracie-academy",
    category: "commercial",
    previewPath: "jiu-jitsy",
    titleUA: "Jiu Jitsy",
    titleEN: "Jiu Jitsy",
    locationUA: "New York, USA",
    locationEN: "New York, USA",
    year: "2024",
    area: "220 m\u00B2",
    descriptionUA: "Академія бразильського джиу-джитсу в Нью-Йорку з функціональним дизайном простору.",
    descriptionEN: "Brazilian jiu-jitsu academy in New York with functional space design.",
    planPdfs: [],
    gallery: [
      { src: wixP("542a9a_5a94fcff0a3a48aa969722358b1f924a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_f5a247e25fed4bf4ae1b40a240b8a0be~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_9238594c8b8d40319cc9eff9ecc4b5f4~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_c27efdbc87714fb3a136516ce3bd3e08~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_fb1426519ed54524b7452c479d14890a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_c6a3d208d0a54c6db614147e3d26d107~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_5034ef0ce48444fa8d7634b31e277c29~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_87eb7d66a5b4482d9a308bde8bc3f91a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_0720cc3f27f649b9a0f5788e86d21aad~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_2826441e576f4265962a9d74d70b5dfe~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_6621cf36c46745e0a88611d144c290b2~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_487f4bade87b4ff8a09b7f8ffa1843da~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_1f25e8f27b364abb9554b3628dd4294a~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "maya-australia",
    slug: "maya-australia",
    category: "interiors",
    previewPath: "maya",
    titleUA: "Maya",
    titleEN: "Maya",
    locationUA: "Австралія",
    locationEN: "Australia",
    year: "2024",
    area: "480 m\u00B2",
    descriptionUA: "Архітектурний проєкт розкішної вілли в Австралії з унікальною концепцією фасадів.",
    descriptionEN: "Architectural project for a luxury villa in Australia with unique facade concept.",
    planPdfs: [],
    // Order + sections: Maya Australia zip — `Facade/` vs interior files (pHash).
    gallery: [
      { src: wixP("542a9a_bd92fa505a774b588a496e4294bde60d~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_59c92825add541ba9c208f1604cf4c6c~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_59c92825add541ba9c208f1604cf4c6c~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_44a1f6500205442bb23d42bf57eb87c0~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_bd92fa505a774b588a496e4294bde60d~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_3bb8796ff5ae4c3685f0d73b4001e775~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_809270479a124a1287c3aa720667b1be~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_578fb68d469545d38ff16fa708f0142c~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_26fb61b1d6774c86a5ec61f34a9872ed~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_49cafee3cc5049a9abbddb9ca8b8e5df~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_92011f2e3f914436901c081073cbf2c6~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_4b45171813e642b09c14ad59755a76f9~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_34a5f75c238445fbb11bc4ab0e06e517~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_c22351a8c5e74da0956f5e6582f2c395~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_9c1a77f51c0f484ca05369f9b80b415a~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_1e049c9c8ed8459e8eadff7e5f6bbba4~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "private-house-prociv",
    slug: "private-house-prociv",
    category: "architecture",
    previewPath: "prociv",
    titleUA: "Prociv",
    titleEN: "Prociv",
    locationUA: "Україна",
    locationEN: "Ukraine",
    year: "2024",
    area: "180 m\u00B2",
    descriptionUA: "Приватний будинок з продуманим інтер\u2019єром: вітальня, гостьові кімнати та санвузли.",
    descriptionEN: "Private house with thoughtful interior: living room, guest rooms and bathrooms.",
    drawings: [],
    planPdfs: [
      {
        href: "/pdfs/private-house-prociv/main.pdf",
        labelUA: "Переглянути план проєкту (PDF)",
        labelEN: "View project plan (PDF)",
      },
      {
        href: "/pdfs/private-house-prociv/plans-enlarged.pdf",
        labelUA: "Плани збільшеного масштабу (PDF)",
        labelEN: "Enlarged plans (PDF)",
        secondary: true,
      },
    ],
    // Order + sections: `Private house Prociv` zip — Living / Guest / wc (pHash); no separate «master» on site set.
    gallery: [
      { src: wix("542a9a_94d0d2956b7344c0a43377aae8a11795~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_bfb08aa7fb434f498bef1f1b8c3c41d0~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_4879e8163e914f13addabfbfebedfedb~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_bfb08aa7fb434f498bef1f1b8c3c41d0~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_8d4dfa0097374d8bbf7089a3f8d3ceb1~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_f1228541437d47879bdb2df8330b7b5b~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_94d0d2956b7344c0a43377aae8a11795~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_7345f2744e584834bc8b6630054fc96e~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_a1b9e140e1704b9188414f01b7810725~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_10f0e187deea433fa407bbb222583c01~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_cc8a994a90b24dcd85dace0f02f54411~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_7345f2744e584834bc8b6630054fc96e~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "solonka-cottages",
    slug: "solonka-cottages",
    category: "interiors",
    previewPath: "solonka",
    titleUA: "Solonka",
    titleEN: "Solonka",
    locationUA: "Львівська обл.",
    locationEN: "Lviv Region",
    year: "2024",
    area: "180 m\u00B2",
    descriptionUA: "Котеджний комплекс у мальовничому Солонці: кухня, вітальня, фасади.",
    descriptionEN: "Cottage complex in picturesque Solonka: kitchen, living room, facades.",
    drawings: [],
    planPdfs: [
      {
        href: "/pdfs/solonka-cottages/solonka-serenity-module-1.pdf",
        labelUA: "Переглянути план проєкту (PDF)",
        labelEN: "View project plan (PDF)",
      },
    ],
    // Order + sections: `Solonka cottages` zip filenames Kitchen_* / Living room_* / Facade_* (pHash).
    gallery: [
      { src: wixP("542a9a_880f10734d684d8088d37ad4bd2d8bcf~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_27e6d375451e465cbd0fb1ae99406511~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_f5d0762b9bc04aeeab3a6b2a546ce48d~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_bd6df6f7ad4d4c4e9093b58821680935~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_7830fa8ededf4f8ca178bac592c137df~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_0ddb2135119e4728b1cda46bc8deceda~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_494413e25fa54d60bdd96a33fcbbdb9f~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_4d967a081de241d8b56561a83ccb2b9d~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_56820fee2b7644288296d00fb50463ca~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_431ddcd6732d48089e50f6bf82cb8c3b~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_e4d4ec9717044e028d150e524f6b1c0d~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_3720443a755946d0bb13e1bf161ef9d4~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_121e30913b4040b09b99bbbd1155a448~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "the-element",
    slug: "the-element",
    category: "interiors",
    previewPath: "element",
    titleUA: "Element",
    titleEN: "Element",
    locationUA: "Україна",
    locationEN: "Ukraine",
    year: "2024",
    area: "120 m\u00B2",
    descriptionUA: "Архітектурний проєкт із вишуканим інтер\u2019єром: вітальня, кухня, спальня, деталі.",
    descriptionEN: "Architectural project with refined interior: living room, kitchen, bedroom, crafted details.",
    drawings: [],
    planPdfs: [
      {
        href: "/pdfs/the-element/the-element-project.pdf",
        labelUA: "Переглянути план проєкту (PDF)",
        labelEN: "View project plan (PDF)",
      },
    ],
    // Curatorial: 14 = вітальня·кухня + деталі (ширма); 6 = спальня·санвузол (pHash zip zones).
    gallery: [
      { src: wixP("542a9a_a3ed02cebdab40b3aa3241d4fc4d4d9e~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_e7f27b0c80364b54a7cdc5ee61730bec~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_6adfcca155e5427a93ba9bc5eb7d2de1~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_9942f25429464a4ab0389366099a3cb6~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_75d569b745414435a3072b756c00d4bd~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_a21f2f694cd442ecaa18a6795e7a9f12~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_28ce103dadd64e088e71e53192e7329d~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_0c83b35b026c47b78d9305235f176d64~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_adc8723892b04a4cb5472b09352097d9~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_6c6d59ebb1ca48798b32f0c0d2925717~mv2"), w: 900, h: 1200 },
      { src: wix("542a9a_1d6acf0fb32842c0adcdfa8a3a171370~mv2"), w: 1200, h: 900 },
      { src: wix("542a9a_74ff04ab205243b79e679181b5461df9~mv2"), w: 1200, h: 900 },
      { src: wixP("542a9a_8b6d93955fa9462eb11bc5de42205d2a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_d26910db76864feb99b9867da41f5b87~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_23018de442a04ab59f214a216471ea76~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_5032f96c6f89407eaa3cd2d02ce13b7a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_7c93649c639342bead7e39a55d952ebe~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_50eb1f2231a94d6f8f1206a969908486~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_87bf65275cb44f34ad6b6815fc683a77~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_e8e7e51c37be43e093c4e38242b56b16~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "ternopil-zamkova",
    slug: "ternopil-zamkova",
    category: "interiors",
    titleUA: "Тернопіль, вул. Замкова",
    titleEN: "Ternopil, Zamkova St.",
    locationUA: "Тернопіль",
    locationEN: "Ternopil",
    year: "2024",
    area: "85 m\u00B2",
    descriptionUA: "Дизайн квартири на вулиці Замковій у Тернополі: кухня-вітальня та спальня.",
    descriptionEN: "Apartment design on Zamkova Street in Ternopil: kitchen-living room and bedroom.",
    planPdfs: [],
    gallery: [
      { src: wixP("542a9a_5553cb49ed2842d8a7f1e7245afa7908~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_813641e0f0194def9d9d673507e81dfc~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_f29e85f3b4d240a0a3518632fea02a9a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_9733a1fba4a846ef9fa6fb7b96653195~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_3ef9f735693046cfa4a350053cdd0d05~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_d928993713c14ff09c4f180b7842fe9a~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_e7ba618492f2416cb036abe00fa16e04~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_38bcc5c0c32c49ce9a6b898cb274ee6e~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_d97739cbf53d4e5a8b931e5aa3ad654b~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_b8b17e65a90d46faa9d1079bf7e9a3ab~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_52bf21c316f648feb6f3c4d7c4353847~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_37740062e4e944d3919050992b01a3a2~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_0e6ade8589844e339e57fb1c2dbdc575~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "derma-life",
    slug: "derma-life",
    category: "commercial",
    previewPath: "derma",
    titleUA: "Derma",
    titleEN: "Derma",
    locationUA: "Львів",
    locationEN: "Lviv",
    year: "2024",
    area: "130 m\u00B2",
    descriptionUA: "Дизайн інтер\u2019єру клініки Derma LIFE у Львові — сучасний комерційний простір.",
    descriptionEN: "Interior design for Derma LIFE clinic in Lviv — modern commercial space.",
    planPdfs: [],
    gallery: [
      { src: wixP("542a9a_35a344448ee3440db68f08f9396eee7c~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_977492d65424402b9c2f9bee4edd7531~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_fd230ce6b23e407f9a83e48c4657ffb7~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_6a60e4270dde46838f886ebc89365531~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_411a0ad903df4ce59ed526bdf2751ed2~mv2"), w: 900, h: 1200 },
      { src: wixP("542a9a_4f7e98ad8bef433492935e5606591eb7~mv2"), w: 900, h: 1200 },
    ],
  },
  {
    id: "zhk-aristokrat",
    slug: "zhk-aristokrat",
    category: "interiors",
    titleUA: "ЖК Аристократ",
    titleEN: "ZhK Aristokrat",
    locationUA: "Львів",
    locationEN: "Lviv",
    year: "2024",
    area: "95 m\u00B2",
    descriptionUA: "Елегантність у кожній деталі. Інтер\u2019єр, що поєднує сучасну естетику, безкомпромісну якість та вишуканий комфорт у престижному серці Львова.",
    descriptionEN: "Elegance in every detail. An interior combining modern aesthetics, uncompromising quality and refined comfort in the prestigious heart of Lviv.",
    planPdfs: [],
    gallery: [
      { src: "https://res2.weblium.site/res/683f0c1d5fa86d50fa4cdb30/684d912dd82130a88eb084f1_optimized_1348", w: 1348, h: 1011 },
      { src: "https://res2.weblium.site/res/683f0c1d5fa86d50fa4cdb30/684d9124d3b4e0c14f783d94_optimized_1019", w: 1019, h: 764 },
      { src: "https://res2.weblium.site/res/683f0c1d5fa86d50fa4cdb30/684d9118d82130a88eb0848d_optimized_1019", w: 1019, h: 764 },
    ],
  },
  {
    id: "avalon-yard",
    slug: "avalon-yard",
    category: "architecture",
    previewPath: "avalon-yard",
    titleUA: "Avalon Yard",
    titleEN: "Avalon Yard",
    locationUA: "Україна",
    locationEN: "Ukraine",
    year: "2024",
    area: "110 m\u00B2",
    descriptionUA: "Сучасний інтер\u2019єр апартаментів Avalon Yard — студійний простір з витонченою естетикою.",
    descriptionEN: "Modern Avalon Yard apartment interior — studio space with refined aesthetics.",
    planPdfs: [],
    // Order aligned with source files `240115_Avalon Yard_Studio_1..5` + `_62` (Studio_52 is local-only duplicate of CDN set).
    gallery: [
      { src: weblium("684db337d3b4e0c14f789f25"), w: 1200, h: 900 },
      { src: weblium("684db31f6775d3727cdf8198"), w: 1200, h: 900 },
      { src: weblium("684db307cbfab8d2b1c010ef"), w: 1200, h: 900 },
      { src: weblium("684db2f1cbfab8d2b1c010b4"), w: 1200, h: 900 },
      { src: weblium("6845b01b0dde00b68f9e595a"), w: 1200, h: 900 },
      { src: weblium("684db2d4d3b4e0c14f789e2b"), w: 1200, h: 900 },
    ],
  },
];

/**
 * Per-slug slice plan: counts must sum to gallery.length for that project.
 * `before_after_fragment` optional on any row — reserved for short before/after clips (dormant until set).
 */
const SECTION_PLAN = {
  "hodosivka-residence": [
    { id: "studio", labelUA: "Студія", labelEN: "Studio", count: 5 },
    { id: "bedroom-wardrobe", labelUA: "Спальня / гардероб", labelEN: "Bedroom / wardrobe", count: 9 },
    { id: "bath", labelUA: "Санвузли", labelEN: "Bathrooms", count: 3 },
    { id: "gym", labelUA: "Спортзал / ігрова", labelEN: "Gym · playroom", count: 3 },
  ],
  "igor-gracie-academy": [{ id: "academy", labelUA: "Зала тренувань", labelEN: "Training hall", count: 13 }],
  "maya-australia": [
    { id: "interior", labelUA: "Інтер'єр", labelEN: "Interior", count: 12 },
    { id: "facade", labelUA: "Фасад", labelEN: "Facade", count: 4 },
  ],
  "private-house-prociv": [
    { id: "living-guest", labelUA: "Вітальня / гостьові", labelEN: "Living / guest rooms", count: 10 },
    { id: "bath", labelUA: "Санвузли", labelEN: "Bathrooms", count: 2 },
  ],
  "solonka-cottages": [
    { id: "kitchen-living", labelUA: "Кухня / вітальня", labelEN: "Kitchen / living", count: 10 },
    { id: "facade", labelUA: "Фасад", labelEN: "Facade", count: 3 },
  ],
  "the-element": [
    {
      id: "living-kitchen-details",
      labelUA: "Вітальня / кухня / деталі",
      labelEN: "Living / kitchen / details",
      count: 14,
    },
    { id: "bedroom-bath", labelUA: "Спальня / санвузол", labelEN: "Bedroom / bathroom", count: 6 },
  ],
  "ternopil-zamkova": [
    { id: "kitchen-living", labelUA: "Кухня / вітальня", labelEN: "Kitchen / living", count: 7 },
    { id: "bedroom", labelUA: "Спальня", labelEN: "Bedroom", count: 6 },
  ],
  "derma-life": [{ id: "clinic", labelUA: "Derma LIFE", labelEN: "Derma LIFE", count: 6 }],
  "zhk-aristokrat": [{ id: "interior", labelUA: "ЖК Аристократ", labelEN: "ZhK Aristokrat", count: 3 }],
  "avalon-yard": [{ id: "studio", labelUA: "Студія", labelEN: "Studio", count: 6 }],
};

function attachMediaSections(project) {
  const plan = SECTION_PLAN[project.slug];
  const gallery = project.gallery || [];
  if (!plan?.length) {
    return {
      ...project,
      mediaSections: [
        {
          id: "all",
          labelUA: "Усі знімки",
          labelEN: "All images",
          images: [...gallery],
        },
      ],
    };
  }
  let offset = 0;
  const mediaSections = plan.map((row) => {
    const slice = gallery.slice(offset, offset + row.count);
    offset += row.count;
    const section = {
      id: row.id,
      labelUA: row.labelUA,
      labelEN: row.labelEN,
      images: slice,
    };
    if (row.before_after_fragment) {
      section.before_after_fragment = row.before_after_fragment;
    }
    return section;
  });
  if (offset < gallery.length && mediaSections.length) {
    mediaSections[mediaSections.length - 1].images.push(...gallery.slice(offset));
  }
  return { ...project, mediaSections };
}

export const projects = rawProjects.map(attachMediaSections);

/** Curated subset for homepage editorial mosaic — full archive on /portfolio. */
export const FEATURED_HOME_SLUGS = [
  'hodosivka-residence',
  'maya-australia',
  'the-element',
  'solonka-cottages',
  'private-house-prociv',
  'igor-gracie-academy',
  'ternopil-zamkova',
  'avalon-yard',
];

export function getFeaturedHomeProjects() {
  return FEATURED_HOME_SLUGS.map((slug) => projects.find((p) => p.slug === slug)).filter(Boolean);
}

/** Curated 10-project editorial grid on /portfolio (homepage order + two further projects). */
export const PORTFOLIO_INDEX_GRID_SLUGS = [
  ...FEATURED_HOME_SLUGS,
  'derma-life',
  'zhk-aristokrat',
];

export function getPortfolioIndexGridProjects() {
  return PORTFOLIO_INDEX_GRID_SLUGS.map((slug) => projects.find((p) => p.slug === slug)).filter(Boolean);
}

/**
 * Guard: SECTION_PLAN row counts must match gallery length when a plan exists.
 * @returns {Array<{ slug: string, sum: number, glen: number }>}
 */
export function verifySectionPlanIntegrity() {
  const issues = [];
  for (const p of rawProjects) {
    const plan = SECTION_PLAN[p.slug];
    if (!plan?.length) continue;
    const sum = plan.reduce((a, r) => a + r.count, 0);
    const glen = (p.gallery || []).length;
    if (sum !== glen) issues.push({ slug: p.slug, sum, glen });
  }
  return issues;
}

/** Ordered zones for the project detail gallery (always non-empty). */
export const getProjectMediaSections = (project) =>
  project?.mediaSections?.length
    ? project.mediaSections
    : [{ id: "all", labelUA: "Усі знімки", labelEN: "All images", images: project?.gallery || [] }];

/** Flattened gallery for lightbox, previews, and length checks. */
export const getProjectFlatGallery = (project) =>
  getProjectMediaSections(project).flatMap((s) => s.images);

export const getProjectBySlug = (slug) => projects.find((p) => p.slug === slug);

export const getProjectsByCategory = (category) => {
  if (category === "all") return projects;
  return projects.filter((p) => p.category === category);
};

/** Portfolio filters — three SATI practice lines only (no generic “all” chip; default view shows full grid). */
export const categories = [
  { id: "interiors", labelUA: "Інтер\u2019єри", labelEN: "Interiors" },
  { id: "architecture", labelUA: "Архітектура", labelEN: "Architecture" },
  { id: "commercial", labelUA: "Комерція", labelEN: "Commercial" },
];

/** Preview image: use local WebP/JPG under public/images/projects/{previewPath}/ when present, else first flat image. */
export const getPreviewImage = (project) => {
  const first = getProjectFlatGallery(project)[0]?.src;
  if (project.previewPath) {
    return {
      webp: `/images/projects/${project.previewPath}/preview.webp`,
      jpg: `/images/projects/${project.previewPath}/preview.jpg`,
      fallback: first,
    };
  }
  return { fallback: first };
};
